import { UnitTypes, Units } from "../types/sharedTypes";

export const unitFormatter = (
  value: number,
  unitType: UnitTypes,
  currentUnit: Units,
  round?: boolean,
  reverse?: boolean
) => {
  let result = 0;
  switch (unitType) {
    case UnitTypes.Bar:
      // Bar to PSI
      result =
        currentUnit === Units.Metric
          ? value
          : reverse
          ? value / 14.5
          : value * 14.5;
      break;
    case UnitTypes.Liter:
      // Liter to Gallon (US)
      result =
        currentUnit === Units.Metric
          ? value
          : reverse
          ? value * 3.785
          : value / 3.785;
      break;
    case UnitTypes.Meter:
      // Meter to food
      result =
        currentUnit === Units.Metric
          ? value
          : reverse
          ? value / 3.28084
          : value * 3.28084;
      break;
    // Newton is newton
    case UnitTypes.Newton:
      result = value;
      break;
  }

  // Return rounded to two decimals or if "round" completely rounded.
  return round ? Math.floor(result) : Math.round(result * 100) / 100;
};
